module.exports = __webpack_public_path__ + "static/media/owu_logo.360dcc78.svg";